import React, { FC, useContext, useMemo } from 'react';
import { ScreenClassContext } from 'react-grid-system';

import T0 from 'ia-react-core/~/components/titles/T0';
import T3 from 'ia-react-core/~/components/titles/T3';
import FormColContext from '../../components/form/#FormColContext';
import excludeChildrenByType from '../../utils/components/#excludeChildrenByType';
import findChildByType from '../../utils/components/#findChildByType';
import ApplicationLayout from '../ApplicationLayout';
import { ApplicationLayoutProps, ApplicationLayoutStatics } from '../ApplicationLayout/ApplicationLayout';

export interface FormLayoutProps extends ApplicationLayoutProps {}
export interface FormLayoutStatics extends ApplicationLayoutStatics {}

/**
 * @since 1.4.0
 */
const FormLayout: FC<FormLayoutProps> & FormLayoutStatics = ({ children, ...props }) => {
  const upperBreakpoint = useContext(ScreenClassContext);
  const isMobile = useMemo(() => ['xs'].includes(upperBreakpoint), [upperBreakpoint]);
  const headerHeight = useMemo(() => isMobile ? 58 : 82, [isMobile]);
  const beforeHeader = findChildByType(children, ApplicationLayout.BeforeHeader);
  const mainHeaderRightContent = findChildByType(children, ApplicationLayout.MainHeaderRightContent);
  const mainHeaderMiddleContent = findChildByType(children, ApplicationLayout.MainHeaderMiddleContent);

  const content = excludeChildrenByType(children, ApplicationLayout.BeforeHeader, ApplicationLayout.MainHeaderRightContent, ApplicationLayout.MainHeaderMiddleContent);
  const contentVerticalPadding = useMemo(() => isMobile ? 60 : 96, [isMobile]);

  const formColContext = useMemo(() => ({
    defaultCol: 12,
  }), []);

  return (
    <ApplicationLayout
      headerHeight={headerHeight}
      maxContentWidth={560}
      contentVerticalPadding={contentVerticalPadding}
      PrimaryTitle={T0}
      SecondaryTitle={T3}
      {...props}
    >
      {beforeHeader}
      {mainHeaderMiddleContent}
      {mainHeaderRightContent}
      <FormColContext.Provider value={formColContext}>
        {content.map((child, index) => <React.Fragment key={`${index}`}>{child}</React.Fragment>)}
      </FormColContext.Provider>
    </ApplicationLayout>
  );
};

FormLayout.Content = ApplicationLayout.Content;
FormLayout.Footer = ApplicationLayout.Footer;
FormLayout.MainHeaderMiddleContent = ApplicationLayout.MainHeaderMiddleContent;
FormLayout.MainHeaderRightContent = ApplicationLayout.MainHeaderRightContent;
FormLayout.BeforeHeader = ApplicationLayout.BeforeHeader;

export default FormLayout;
